import type { MapLocationDto } from '@/core/data/location/location.interface';
import { LocationChessFeature, LocationType } from '@/core/data/location/location.type';
import { gambits } from '@/core/gambits';
import { useAuthStore } from '@/stores/auth.store';
import { GamButtonMessageVariant } from '@/views/composables/constants/components/gamButton.constants';
import type { GamButtonMessageType } from '@/views/composables/models/components/GamButton';
import type { LocationFormProps } from '@/views/composables/models/form.interface';

export const handleCreateLocation = async (
  locationProps: LocationFormProps,
): Promise<MapLocationDto | GamButtonMessageType | undefined> => {
  const payload: LocationFormProps = {
    name: locationProps.name,
    address: locationProps.address,
    type: Array.isArray(locationProps.type) ? locationProps.type[0] : LocationType.CHESS_FRIENDLY,
    coordinates: locationProps.coordinates,
    chessFeatures: locationProps.chessFeatures,
    generalFeatures: locationProps.generalFeatures,
    photos: locationProps.photos,
    private: false,
  };

  if (typeof locationProps.about === 'string' && locationProps.about.length > 0) {
    payload.about = locationProps.about;
  }

  if (locationProps.chessFeatures.includes(LocationChessFeature.CHESS_SET) && locationProps.chessSetCount! > 0) {
    payload.chessSetCount = locationProps.chessSetCount;
  }

  if (locationProps.chessFeatures.includes(LocationChessFeature.CHESS_CLOCK) && locationProps.chessClockCount! > 0) {
    payload.chessClockCount = locationProps.chessClockCount;
  }

  if (locationProps.chessFeatures.includes(LocationChessFeature.CHESS_TABLE) && locationProps.chessTableCount! > 0) {
    payload.chessTableCount = locationProps.chessTableCount;
  }

  if (locationProps.chessFeatures.includes(LocationChessFeature.GIANT_CHESS)) {
    if (locationProps.giantChessBoardCount) {
      payload.giantChessBoardCount = locationProps.giantChessBoardCount;
    }
    payload.giantChessPieces = locationProps.giantChessPieces;
  }

  if (locationProps.openingHours !== undefined) {
    payload.openingHours = locationProps.openingHours;
  }

  const result = await gambits.locationService.addNewLocation(payload);

  if (result.data) {
    useAuthStore().fetchUserInfo(true);
    return result.data;
  } else if (result.error) {
    return {
      label: result.error.message,
      variant: GamButtonMessageVariant.ERROR,
    };
  }
};
